import { head } from 'lodash'
import { hex } from '../../lib/colorUtil'
import { l } from '../../lib/imports'
import type { ISPD } from '../../sprites/sprites'
import { sprites } from '../../sprites/sprites-sidecar'

export interface IBodyData {
  idx: number
  frames: ISPD[]
  hx: number
  hy: number
}
export interface IHeadData {
  idx: number
  frames: ISPD[]
  ox: number
  oy: number
}

export interface IHairAdjust {
  ox: number
  oy: number
  sx: number
  sy: number
}
export interface IHairData {
  idx: number
  frames: ISPD[]
  // ox: number
  // oy: number
  adj: IHairAdjust[]
}

export const bodies: IBodyData[] = [
  {
    idx: 0,
    frames: sprites.voyBody1,
    hx: 0,
    hy: 0,
  },
  {
    idx: 1,
    frames: sprites.voyBody2,
    hx: 0,
    hy: 0,
  },
  {
    idx: 2,
    frames: sprites.voyBody3,
    hx: 0,
    hy: 0,
  },
  {
    idx: 3,
    frames: sprites.voyBody4,
    hx: 0,
    hy: 0,
  },
]

export const heads: IHeadData[] = [
  {
    idx: 0,
    frames: sprites.voyHead1,
    ox: 0,
    oy: 0,
  },
  {
    idx: 1,
    frames: sprites.voyHead2,
    ox: 0,
    oy: 0,
  },
]

export const hairs: IHairData[] = [
  {
    idx: 0,
    frames: sprites.voyHairBowl,
    adj: [],
    // ox: 1,
    // oy: 0,
  },
  {
    idx: 1,
    frames: sprites.voyHairBuzz,
    adj: [],
    // ox: 2,
    // oy: 0,
  },
  {
    idx: 2,
    frames: sprites.voyHairPigtails,
    adj: [],
    // ox: -1,
    // oy: 0,
  },
  {
    idx: 3,
    frames: sprites.voyHairOld,
    adj: [],
    // ox: 0,
    // oy: 3,
  },
  {
    idx: 4,
    frames: sprites.voyHairSpikes,
    adj: [],
    // ox: 3,
    // oy: -2,
  },
  {
    idx: 5,
    frames: [],
    adj: [],
    // ox: 0,
    // oy: 0,
  },
]

export function processHairAdj() {
  l.forEach(heads, (c) => {
    l.forEach(hairs, (d) => {
      d.adj.push({
        ox: 0,
        oy: 0,
        sx: 1,
        sy: 1,
      })
    })
  })
}
processHairAdj()

// see: https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/a60d4c7d-23c6-4e9d-a143-cc2d471feb33/dbfxlq0-f221882e-e548-4023-9aea-b414a2a5d5f2.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2E2MGQ0YzdkLTIzYzYtNGU5ZC1hMTQzLWNjMmQ0NzFmZWIzM1wvZGJmeGxxMC1mMjIxODgyZS1lNTQ4LTQwMjMtOWFlYS1iNDE0YTJhNWQ1ZjIucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.FIpwgMEDeYbjp-r_gM-CVi7zqs7F-pjIblVq2y2bfe8
export const hairColors: number[] = [
  hex('#C2B09F'),
  hex('#869D48'),
  hex('#CF9CC7'),
  hex('#F68045'),

  hex('#FDFBD1'),
  hex('#7CBA90'),
  hex('#E59BC3'),
  hex('#FF9E59'),

  hex('#FAD472'),
  hex('#A0B6B6'),
  hex('#FFBB99'),
  hex('#E0A56B'),

  hex('#C29242'),
  hex('#7E7B97'),
  hex('#FF6159'),
  hex('#B27D60'),

  hex('#EDCD6B'),
  hex('#AEB9FF'),
  hex('#9E3126'),
  hex('#BA9685'),

  hex('#D2BA5B'),
  hex('#C1BFD7'),
  hex('#ED6748'),
  hex('#806C75'),
]

// see: https://dch81km8r5tow.cloudfront.net/wp-content/uploads/2016/05/Dass_Angelica_Humanae_-Collage02.jpg
export const skinTones: number[] = [
  hex('#B97F67'),
  hex('#E9BAA2'),
  hex('#CA8E74'),
  hex('#E7BFA5'),
  hex('#A57461'),

  hex('#F8D5C2'),
  hex('#D19B7E'),
  hex('#F7E4D6'),
  hex('#F0D4C1'),
  hex('#DBAD92'),

  hex('#E9C6B3'),
  hex('#E9C9B7'),
  hex('#CD9A7D'),
  hex('#DCAB94'),
  hex('#927571'),

  hex('#E5AF8C'),
  hex('#F0C7BF'),
  hex('#F0B996'),
  hex('#DDAA8D'),
  hex('#EDD3C8'),

  hex('#EDCDBD'),
  hex('#C28665'),
  hex('#F5DBCA'),
  hex('#F5D3B9'),
  hex('#E8C7B4'),

  hex('#F2D9CB'),
  hex('#DBA584'),
  hex('#EFDCD5'),
  hex('#F3D7C9'),
  hex('#CB9177'),
]

// see: https://lospec.com/palette-list/paper-pixels
export const clothesColors: number[] = [
  hex('#D6C7A3'),
  hex('#ADA387'),
  hex('#CC9970'),
  hex('#A97E5C'),
  hex('#937B6A'),

  hex('#A0A0A0'),
  hex('#838383'),
  hex('#839CA9'),
  hex('#6D838E'),
  hex('#C87E7E'),

  hex('#A05E5E'),
  hex('#B089AB'),
  hex('#8E6D89'),
  hex('#B9AB73'),
  hex('#978C63'),

  hex('#87A985'),
  hex('#6F8B6E'),
]
